import { UPCLAIM_ROLES } from "@upclaim/sdk/src/admin-roles";

import { Combobox } from "@/components/combobox";
import { Label } from "@/components/ui/label";
import { useCurrentUser } from "@/hooks/use-current-user";

import { ADVERSARY_REFUSAL_REASONS, type AdversaryRefusalReason } from "../lib/adversary-refusal-reasons";

interface AdversaryRefusalReasonComboboxProps {
  value: AdversaryRefusalReason | undefined;
  onChange: (reason: AdversaryRefusalReason | undefined) => void;
  label?: string;
  disabled?: boolean;
}

/** Port of Comboboxes/AdversaryRefusalReasonComboBox.vue. */
export function AdversaryRefusalReasonCombobox({
  value,
  onChange,
  label = "Raison refus adversaire",
  disabled = false,
}: AdversaryRefusalReasonComboboxProps) {
  const { can } = useCurrentUser();

  const isDisabled = disabled || !can(UPCLAIM_ROLES);

  return (
    <div>
      <Label className="mb-2 block text-sm font-medium leading-6 text-gray-900">{label}</Label>
      <Combobox
        items={ADVERSARY_REFUSAL_REASONS}
        value={value ?? null}
        onChange={(reason) => onChange(reason ?? undefined)}
        getKey={(reason) => reason.id}
        getLabel={(reason) => reason.displayName}
        renderItem={(reason) => (
          <>
            <reason.icon className="h-4 w-4 text-blue-600" />
            <span className="ml-1 truncate">{reason.displayName}</span>
          </>
        )}
        placeholder="Aucune"
        searchPlaceholder="Rechercher..."
        emptyMessage="Aucune raison trouvée"
        unselectLabel="Aucune"
        disabled={isDisabled}
      />
    </div>
  );
}
